const outcomeNumbersPage = `
{{#> hartford/NavLayout currentPage=currentPage Pages=Pages basePath=basePath logoUrl=project.values.logoUrl }}
  <div class="outcome-numbers-page">
    <div class="big-text-section">
      <div class="big-text">{{project.values.outcomeNumbersText}}</div>
    </div>

    <div class="container">
      <div class="metrics-container">
        {{#each pageContext.outcome_numbers}}
          <div class="metric-card">
            <div class="metric-content">
              <h3 class="metric-title">{{this.title}}</h3>
              <p class="metric-description">{{this.description}}</p>
            </div>
          </div>
        {{/each}}
      </div>

      <div class="quote-section">
        <div class="quote-container">
          <div class="quote-mark">"</div>
          <blockquote class="quote-text">
            {{pageContext.quote.[0].quote}}
          </blockquote>
        </div>
      </div>
    </div>
  </div>
{{/hartford/NavLayout}}
`;

const outcomeNumberItem = `
<div class="metric-card">
  <div class="metric-content">
    <h3 class="metric-title">{{this.title}}</h3>
    <p class="metric-description">{{this.description}}</p>
  </div>
</div>
`;

const outcomeNumbersPageStyles = `
  .outcome-numbers-page {
    background-color:rgb(248, 246, 241);
  }

  .container {
    width: 100%;
    max-width: 1140px;
    margin: 0 auto;
    padding: 0 15px;
  }

  .big-text-section {
    background-color: #f8f9fa;
    padding: 60px 30px;
    border-radius: 8px;
    margin-bottom: 60px;
  }

  .big-text {
    font-size: 36px;
    line-height: 1.4;
    color: #333;
    font-weight: 300;
    text-align: center;
  }

  .metrics-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
    margin-bottom: 80px;
  }

  .metric-card {
    flex: 0 0 calc(50% - 30px);
    max-width: calc(50% - 30px);
    padding: 30px;
    transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1), box-shadow 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    display: flex;
    align-items: center;
    text-align: left;
  }

  .metric-icon {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: rgba(0, 102, 204, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    flex-shrink: 0;
    color: #0066cc;
    transition: transform 0.3s ease, background-color 0.3s ease;
  }

  .metric-card:hover .metric-icon {
    transform: scale(1.1);
    background-color: rgba(0, 102, 204, 0.15);
  }

  .metric-content {
    flex: 1;
  }

  .metric-title {
    font-size: 48px;
    font-weight: 700;
    color: #0066cc;
    margin: 0 0 10px 0;
    text-align: center;
  }

  .metric-description {
    font-size: 24px;
    line-height: 1.6;
    color: #333;
    margin: 0;
    text-align: center;
  }

  /* Quote Section Styles */
  .quote-section {
    padding: 80px 0;
    position: relative;
    overflow: hidden;
  }

  .quote-container {
    max-width: 900px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    padding: 40px 20px;
  }

  .quote-mark {
    font-size: 120px;
    line-height: 1;
    color: #FF9D23;
    font-family: Georgia, serif;
    position: absolute;
    top: -20px;
    left: 0;
    z-index: 0;
  }

  .quote-text {
    font-size: 32px;
    line-height: 1.4;
    color: #333;
    font-style: italic;
    margin: 0;
    position: relative;
    z-index: 1;
    font-weight: 300;
  }

  @media (max-width: 992px) {
    .metric-card {
      flex: 0 0 calc(50% - 20px);
      max-width: calc(50% - 20px);
      padding: 25px;
    }

    .quote-text {
      font-size: 28px;
    }
  }

  @media (max-width: 768px) {
    .metrics-container {
      gap: 20px;
    }

    .metric-card {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .metric-icon {
      width: 60px;
      height: 60px;
    }

    .metric-title {
      font-size: 22px;
    }
  }

  @media (max-width: 576px) {
    .outcome-numbers-page {
      padding: 40px 0;
    }

    .headline {
      font-size: 28px;
      margin-bottom: 40px;
    }

    .metric-card {
      padding: 20px;
    }

    .quote-section {
      padding: 60px 0;
    }

    .quote-text {
      font-size: 22px;
    }
  }
`;

export const outcomeNumbersBlocks: any[] = [
  {
    name: 'hartford/OutcomeNumbersPage',
    partial: outcomeNumbersPage,
    css: outcomeNumbersPageStyles,
  },
  {
    name: 'hartford/OutcomeNumberItem',
    partial: outcomeNumberItem,
    css: outcomeNumbersPageStyles,
  },
];
